module.exports = __webpack_public_path__ + "img/hospital ex.186a2af8.webp";